<template>
    <wow-card :show-title="false" elevation="0">
        <v-row>
            <v-col class="py-0" cols="12" md="4" lg="4" xs="12" sm="4">
                <v-autocomplete
                    v-model="selectedCenter"
                    placeholder="--Select Center--"
                    :items="franchisee"
                    key="model"
                    item-text="companyName"
                    hide-details
                    return-object
                ></v-autocomplete>
            </v-col>
            <v-col v-if="selectedCenter" cols="12" md="12" lg="12" xs="12" sm="12">
                <v-data-table
                :headers="headers"
                :items="existingFCIDData"
                hide-default-footer
                disable-pagination
                >
                  <template v-slot:item.boqQuantity="{item}">
                    <div class="d-flex justify-space-between">
                      <span>{{ item.wowKitOrderQuantity ? item.wowKitOrderQuantity : item.quantity }}</span>
                      <v-btn icon @click="openEditQuantityDialog(item)" color="accent" small>
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
                <div class="my-2 d-flex justify-center">
                    <v-btn @click="addMoreProductData" small color="accent">
                        <v-icon small>mdi-plus</v-icon>
                        <span class="ml-1">Add Extra Products</span>
                    </v-btn>
                </div>
                <v-data-table
                  v-if="moreFCIDData.length > 0"
                  :headers="headers"
                  :items="moreFCIDData"
                  hide-default-footer
                  disable-pagination
                >
                    <template v-slot:item.productID="{item}">
                      <v-text-field
                        :class="!item.isError ? '': 'my-1'"
                        outlined
                        dense
                        :hide-details="!item.isError"
                        v-model="item.productID"
                        placeholder="Enter FCID"
                        :error="item.isError"
                        :error-messages="item.errorText"
                        @blur="validateProductData(item)"
                      ></v-text-field>
                    </template>
                    <template v-slot:item.boqQuantity="{item}">
                      <div class="d-flex justify-space-between">
                        <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model="item.boqQuantity"
                          placeholder="Enter BOQ Quantity"
                          @input="updateBomQuatityData(item)"
                          :disabled="item.isError"
                          class="mr-1"
                        ></v-text-field>
                        <div class="action-button">
                          <v-btn
                            v-if="item.productID && !item.isError && !item.save"
                            icon
                            color="accent"
                            small
                            @click="addExtraProduct(item)"
                          >
                            <v-icon small>mdi-content-save</v-icon>
                          </v-btn>
                          <v-btn
                          v-if="!item.save"
                            icon
                            color="error"
                            small
                            @click="deleteExtraProduct(item)"
                          >
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-card-actions v-if="selectedCenter" class="d-flex justify-end">
          <v-btn :disabled="!enableProceedForApproval || !selectedFranchiseeId || existingFCIDData.length <= 0" @click.prevent="createInitiateProduct" color="success" small>
            <v-icon small>mdi-check</v-icon>
            <span class="ml-1">Proceed For Approval</span>
          </v-btn>
        </v-card-actions>
        <wow-dialog
          :fullscreen="false"
          :title="`Edit Quantity`"
          v-model="editQuantityDialog"
          persistent
          @close="closeEditQuantityDialog"
          width="400"
        >
          <wow-card :show-title="false">
            <v-row>
              <v-col cols="12" md="12" lg="12" xs="12" sm="12">
                <v-text-field
                  dense
                  hide-details
                  v-model="editQuantityObj.quantity"
                  placeholder="Edit Bom Quantity"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12" lg="12" xs="12" sm="12">
                <label class="font-weight-medium body-2">
                  Reason
                  <span class="requir error--text">*</span>
                </label>
                <v-textarea
                  name="input-7-1"
                  placeholder="Reason to edit Bom Quantity"
                  v-model="editQuantityObj.reason"
                  outlined
                  dense
                  rows="2"
                  hide-details
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="12" lg="12" xs="12" sm="12">
                <v-card-actions class="px-0 d-flex justify-end">
                  <v-btn small @click="editQuantityDialog = false" color="error">Cancel</v-btn>
                  <v-btn small @click="updateBoqQuantity" color="accent">Save</v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </wow-card>
        </wow-dialog>
    </wow-card>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import _ from 'lodash'
import WowCard from './vCard'
import WowDialog from '@/components/Orders/WowKitOrdering/kitComponents/dialog/dialogComponent'
export default {
  name: 'initiateOrder',
  components: {
    WowCard,
    WowDialog
  },
  data () {
    return {
      franchisee: [],
      selectedCenter: null,
      selectedFranchiseeId: null,
      headers: [
        { text: 'FCID', sortable: false, align: 'center', value: 'productID' },
        { text: 'Bom Quantity', sortable: false, align: 'center', value: 'quantity' },
        { text: 'BOQ Quantity', sortable: false, align: 'center', value: 'boqQuantity' }
      ],
      existingFCIDData: [],
      moreFCIDData: [],
      editQuantityDialog: false,
      editQuantityObj: {},
      wowKitSetModalMapID: null,
      wowKitSetModelId: null,
      enableProceedForApproval: true
    }
  },
  async created () {
    this.getFranchiseeList()
  },
  watch: {
    selectedCenter: {
      handler: async function (newVal, oldVal) {
        if (newVal !== oldVal && newVal) {
          this.selectedFranchiseeId = newVal.id
          this.wowKitSetModelId = newVal.modelID ? newVal.modelID : null
          await this.getInitiatedProduct(this.selectedFranchiseeId)
        }
      },
      deep: true
    }
  },
  methods: {
    openEditQuantityDialog: function (item) {
      this.editQuantityDialog = true
      this.editQuantityObj = {}
      this.editQuantityObj.wowkitsetid = item.wowKitSetMapID ? item.wowKitSetMapID : null
      this.editQuantityObj.productID = item.productID
      this.editQuantityObj.quantity = item.wowKitOrderQuantity ? item.wowKitOrderQuantity : item.quantity
      this.editQuantityObj.reason = item.reason
    },
    closeEditQuantityDialog: function () {
      this.editQuantityDialog = false
    },
    addMoreProductData: function () {
      let productObj = {
        productID: null,
        quantity: 0,
        boqQuantity: 0,
        errorText: '',
        isError: false,
        isSave: false
      }
      this.moreFCIDData.push(productObj)
    },
    updateBomQuatityData: function (item) {
      item.quantity = item.boqQuantity
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        const res = await http.get(`${CONSTANTS.API_URL}/api/franchisee/active`)
        if (res.status === 200) {
          this.franchisee = res.data.rows
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getInitiatedProduct: async function (franchiseeId) {
      try {
        this.existingFCIDData = []
        const res = await http.get(`${CONSTANTS.API_URL}/api/wow-kit/intiated-product-list?franchiseeID=${franchiseeId}`)
        if (res.status === 200) {
          if (res.data.length > 0) {
            this.existingFCIDData = res.data
            this.wowKitSetModalMapID = res.data[0].wowKitSetMapID
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    updateBoqQuantity: async function () {
      try {
        let editObj = this.editQuantityObj
        if (!this.isNumeric(editObj.quantity) || editObj.quantity < 0) {
          this.$dialog.error({
            text: 'Please enter valid quantity',
            title: 'Reason'
          })
          return false
        }
        editObj.quantity = parseInt(editObj.quantity)
        if (editObj.reason === '' || !editObj.reason) {
          return this.$dialog.error({
            text: 'Please provide reason.',
            title: 'Reason'
          })
        }
        let payload = editObj
        const res = await http.put(`${CONSTANTS.API_URL}/api/wow-kit/edit-quantity`, payload)
        if (res.status === 200) {
          this.editQuantityDialog = false
          this.getInitiatedProduct(this.selectedFranchiseeId)
          return this.$dialog.info({
            text: res.data,
            title: 'Success'
          })
        } else {
          return this.$dialog.error({
            text: 'Failed to update quantity for the given FCID.',
            title: 'Error'
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    validateProductData: async function (item) {
      try {
        if (!this.selectedFranchiseeId) {
          return this.$dialog.error({
            text: 'Please select franchisee, before adding extra product.',
            title: 'Error'
          })
        }
        if (!this.wowKitSetModelId) {
          return this.$dialog.error({
            text: 'No Model linked with selected franchisee.',
            title: 'Error'
          })
        }
        let alreadyAddedProductList = _.groupBy(this.existingFCIDData, 'productID')
        if (alreadyAddedProductList[item.productID]) {
          // this.enableProceedForApproval = false
          return this.$dialog.error({
            text: 'Duplicate product id found. Please use diffrent product id or edit the quantity in the existing one.',
            title: 'Error'
          })
        }
        if (!this.isNumeric(item.productID)) {
          item.isError = true
          item.errorText = 'Please Enter Valid Product Id'
          // this.enableProceedForApproval = false
          return false
        }
        if (!item.productID || item.productID === '') {
          item.isError = true
          item.errorText = 'Please Enter Product Id'
          // this.enableProceedForApproval = false
          return false
        }
        let itemObj = {}
        itemObj.productid = parseInt(item.productID)
        itemObj.quantity = parseInt(item.quantity)
        let payload = {}
        payload.model = this.wowKitSetModelId
        payload.csvfile = []
        payload.csvfile.push(itemObj)
        const res = await http.post(`${CONSTANTS.API_URL}/api/wow-kit/validatecsv`, payload)
        if (res.status === 200) {
          if (res.data.status === 99 && !res.data.isValid) {
            item.isError = true
            item.errorText = 'Product ID is incorrect'
            // this.enableProceedForApproval = false
            return false
          } else {
            item.isError = false
            item.errorText = ''
            // this.enableProceedForApproval = true
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    deleteExtraProduct: function (item) {
      let indexOfItem = this.moreFCIDData.indexOf(item)
      this.moreFCIDData.splice(indexOfItem, 1)
    },
    addExtraProduct: async function (item) {
      try {
        item.save = false
        let alreadyAddedProductList = _.groupBy(this.existingFCIDData, 'productID')
        if (alreadyAddedProductList[item.productID]) {
          return this.$dialog.error({
            text: 'Duplicate product id found. Please use diffrent product id or edit the quantity in the existing one.',
            title: 'Error'
          })
        }
        if (!this.isNumeric(item.boqQuantity) || item.boqQuantity < 0) {
          this.$dialog.error({
            text: 'Please enter valid quantity',
            title: 'Reason'
          })
          return false
        }
        let payload = {}
        payload.productid = parseInt(item.productID)
        payload.wowkitsetid = this.wowKitSetModalMapID
        payload.wowkitorderquantity = parseInt(item.boqQuantity)
        const res = await http.post(`${CONSTANTS.API_URL}/api/wow-kit/initiateorderaddnewproduct`, payload)
        if (res.status === 200) {
          item.save = true
          return this.$dialog.info({
            text: res.data.message,
            title: 'Success'
          })
        } else {
          return this.$dialog.error({
            text: 'Failed to update quantity for the given FCID.',
            title: 'Error'
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    createInitiateProduct: async function () {
      try {
        let payload = {}
        payload.franchiseeID = this.selectedFranchiseeId
        payload.modelID = this.wowKitSetModalMapID
        const res = await http.post(`${CONSTANTS.API_URL}/api/wow-kit/initiate-order`, payload)
        if (res.status === 200) {
          this.$dialog.info({
            text: res.data,
            title: 'Success'
          })
          this.selectedCenter = null
          this.selectedFranchiseeId = null
          this.existingFCIDData = []
          this.moreFCIDData = []
          this.$emit('closeOrderInitiateDialog')
        } else {
          return this.$dialog.error({
            text: 'Failed to update quantity for the given FCID.',
            title: 'Error'
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    isNumeric (value) {
      return /^-?\d+$/.test(value)
    }
  }
}
</script>
